<template>
	<section class="px-4 py-1 font-semibold leading-tight bg-dish-red text-white text-center sticky bottom-0 z-30 sm:relative">
		<a :href="url" class="text-xl sm:text-4xl md:text-5xl">Call To Activate <span class="inline-block">{{ phone }}</span></a>
	</section>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'

	import { useDynamicPhoneNumber } from '@/composables/useDynamicPhoneNumber'

	export default defineComponent({
		props: {
			phoneNumber: {
				'type': String,
				'required': false,
				'default': (): string => '1-877-790-1540',
			},
		},

		setup(props) {
			return useDynamicPhoneNumber(props.phoneNumber)
		},
	})
</script>
